import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import hyphenLogo from "../assets/hyphenlogo.png";

function Loader({ isLoading, setIsLoading }) {
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, [setIsLoading]);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          key="loader"
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-paper"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.img
            src={hyphenLogo}
            alt="Hyphen Tech"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-[42vw] max-w-[168px] h-auto object-contain"
          />

          {/* A single gold rule drawing itself — the loading state, stated once. */}
          <div className="w-[42vw] max-w-[168px] h-px bg-[color:var(--rule)] mt-8 overflow-hidden">
            <motion.div
              className="h-full bg-gold origin-left"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>

          <motion.p
            className="label mt-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.4 }}
          >
            Empowering success through technology
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Loader;
